import Emittery from 'emittery'

export type NotificationsEvents = {
  LIKE: undefined
  MATCH: undefined
  MESSAGE: undefined
  SPARK: undefined
}

export const notificationsEventEmitter = new Emittery<NotificationsEvents>()
